//TODO: can probs delete this compnent now.. 
import React, { Component } from "react";
import Feature from "../main/features/Feature.js";
import Hero from "../header/Hero";
import Crisis from "../header/Crisis";

import "./assets/layout.scss";

export default class Layout extends Component {

  constructor(props) {
    super(props);
    this.layout = props.name;
    console.log('woop: ', props)
  }


  render() {
    switch (this.layout) {
      case 'main':
        return this.renderMainLayout();
      case 'standard':
        return this.renderStandardLayout();
      default:
        return this.renderDefaultLayout();
    }
  }

  renderMainLayout() {
    return (
      <div className="layout container-fluid">
        {this.child.props}
      </div>
    );
  }

  renderDefaultLayout() {
    return (
      <div className="layout container-fluid">
        <div className="row primary">
          <Feature name="stories" />
        </div>
        <div className="row secondary">
          <Feature name="asmr" />
        </div>
        <div className="row primary">
          <Feature name="" />
        </div>
        <div className="row secondary">
          <Feature name="feedback" />
        </div>
      </div>
    );
  }

  renderStandardLayout() {
    return (
      <div className="layout container-fluid">
        <Hero />
        <Crisis />
        <div className="arrow-down"></div>
        <p>this is a standard layout</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/layout/Layout.js